import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

document.addEventListener('DOMContentLoaded', function() {
    const workersStepCards = document.querySelectorAll('.workers-steps-container .bg-white');
    
    if (workersStepCards.length > 0) {
        workersStepCards.forEach(card => {
            card.addEventListener('mouseenter', function() {
                this.classList.add('shadow-xl');
                const img = this.querySelector('img');
                if (img) {
                    img.style.transform = 'scale(1.05)';
                    img.style.transition = 'transform 0.5s ease';
                }
            });
            
            card.addEventListener('mouseleave', function() {
                this.classList.remove('shadow-xl');
                const img = this.querySelector('img');
                if (img) {
                    img.style.transform = 'scale(1)';
                }
            });
        });
    }
    const jobStepsSlider = new Swiper('.job-steps-slider', {
        modules: [Navigation],
        slidesPerView: 1.2,
        spaceBetween: 15,
        grabCursor: true,
        navigation: {
            nextEl: '.job-steps-next',
            prevEl: '.job-steps-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 1.5,
                spaceBetween: 20
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1024: {
                slidesPerView: 2.5,
                spaceBetween: 25
            },
            1280: {
                slidesPerView: 3.2,
                spaceBetween: 30
            }
        }
    });
});